import { Box, Skeleton } from '@radix-ui/themes';

const SkeletonLoader = () => {
  return (
    <Box style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
      {[...Array(5)].map((_, index) => (
        <Skeleton key={index} />
      ))}
    </Box>
  );
};

export default SkeletonLoader;